export function safeRedirect(url: string): void {
  if (!isPureUrl(url)) {
    console.error("Blocked Invalidate URL:", url);
    return;
  }
  window.location.assign(url);
}

export function isPureUrl(url: string): boolean {
  if (!url || typeof url !== "string") {
    return false;
  }

  const cleanUrl = url.trim().toLowerCase();

  if (
    cleanUrl.startsWith("http://") ||
    cleanUrl.startsWith("https://") ||
    cleanUrl.startsWith("/")
  ) {
    return true;
  }

  return false;
}
